export default "__VITE_ASSET__cb68a542__"